// libs
import { styled } from '@nykaa/ui-components';

export const WidgetTop = styled.div`
  position: relative;

  & > .pointer {
    position: absolute;
  }
`;
